import { mapApplicationDataResponseToFormValues } from './recover/application-data-response-to-form-values';
import {
  getStateValueForSection,
  validateAndGetFirstInvalidSection,
} from './validation-flow';

import { PartnerApplicationResponse, ROUTE_IDS } from '../model';
import { partnerApplicationMachine } from '../model/partner-application-machine';

/**
 * Maps application it to form context,
 * validates all sections, and returns a resolved snapshot.
 * If any section is invalid, the snapshot resolves to the first invalid section's screen.
 */
export function getPartnerApplicationSnapshot(
  application: PartnerApplicationResponse
) {
  const formValues = mapApplicationDataResponseToFormValues(application);
  const context = {
    ...formValues,
    applicationId: application.applicationId,
    ownership: application.ownership,
    agentDraft: null,
    storeDraft: null,
  };

  const firstInvalidSection = validateAndGetFirstInvalidSection(context, false);
  const value = firstInvalidSection
    ? getStateValueForSection(firstInvalidSection)
    : 'review';

  return partnerApplicationMachine.resolveState({
    value,
    context: {
      ...context,
      navigationStack: value === 'review' ? [ROUTE_IDS.review] : [],
    },
  });
}
